import { AxiosError } from "axios";
import { UseQueryResult, useQuery } from "react-query";
import { StrapiRequest } from "../../../help-center/service/model/HelpCentreService";
import {
  StrapiCMSPromiseType,
  StrapiCMSApiService,
} from "../../../help-center/service/api/StrapiCMSApiService";
import { StrapiComingSoonFeatureResponse } from "../models/ComingSoonService";

const useGetComingSoonFeatureService = ({
  id,
  populate,
}: StrapiRequest): UseQueryResult<
  StrapiComingSoonFeatureResponse,
  AxiosError
> =>
  useQuery<
    Promise<StrapiCMSPromiseType>,
    AxiosError,
    StrapiComingSoonFeatureResponse
  >(["ComingSoonFeatures"], () =>
    StrapiCMSApiService("coming-soon-features", id, populate)
  );

export default useGetComingSoonFeatureService;
